/**
 * Inventory Page React Component
 */
import React from 'react';
import { createRoot, render } from '@wordpress/element';
import { InventoryWrapper } from './InventoryWrapper';
import './inventory-page.css';

function renderComponentSafe(
	Component: React.ComponentType,
	container: Element | null
) {
	if (container === null) {
		return;
	}

	if (typeof createRoot === 'function') {
		const root = createRoot(container!);
		root.render(<Component />);
	} else {
		render(<Component />, container);
	}
}

renderComponentSafe(
	InventoryWrapper,
	document.getElementById('gp_inventory_page_react_root')
);
